import { TEMPLATES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// import { update_current_template } from './'
// import { try_force_logoff } from '../auth'

const update_template_request = () => {
  return {
    type: templatesTypes.update.request
  }
}

const update_template_success = (response) => {
  return {
    type: templatesTypes.update.success,
    payload: response.data.template
  }
}

const update_template_failure = (messages) => {
  return {
    type: templatesTypes.update.failure,
    payload: messages
  }
}

const update_template = (template_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_template_request())

    // Request
    axios.patch(
      formatRoute(TEMPLATES_ROUTES.update, {id: template_id}),
      values
    ).then( response => {
      // success
      if ( values.publish !== undefined && values.publish === true) {
        window.showSnackbar('success', 'The template status has changed to: Published.')
      }
      dispatch( update_template_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating template."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( update_template_failure(errors))
    })
  }

}

export {
  update_template
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/update.js